import React from "react";
import { MapPin, Clock3, Wrench, DollarSign, Smile, CalendarCheck, Award, Home } from "lucide-react";

const ITEMS = [
  { icon: Home,          title: "We Come To You",        desc: "Home, work, or roadside — we bring the shop to your vehicle." },
  { icon: Clock3,        title: "Save Time",             desc: "No waiting rooms. Use your time however you like while we work." },
  { icon: Wrench,        title: "Professional Equipment",desc: "Full mobile setup: mounting, balancing, torque, and TPMS tools." },
  { icon: DollarSign,    title: "Honest Pricing",        desc: "Transparent quotes up front — no hidden fees or upsell games." },
  { icon: Smile,         title: "Friendly Service",      desc: "Local, courteous technicians who treat every vehicle with care." },
  { icon: CalendarCheck, title: "Flexible Scheduling",   desc: "Evenings and weekends available. Book what works for you." },
  { icon: Award,         title: "Quality Workmanship",   desc: "Manufacturer-spec torque, balance and installation every time." },
  { icon: MapPin,        title: "Local Calgary Business",desc: "Proudly serving Calgary, Airdrie, Cochrane, Chestermere, Okotoks." },
];

export const WhyChooseUs = () => {
  return (
    <section id="why" className="section-mv bg-brand-black text-white">
      <div className="container-mv">
        <div className="max-w-2xl">
          <div className="text-xs font-semibold tracking-widest text-brand-red uppercase">Why Mavtech</div>
          <h2 className="mt-3 font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight">
            Built on trust. <span className="text-brand-red">Driven by service.</span>
          </h2>
          <p className="mt-4 text-white/70 text-base leading-relaxed">
            Every vehicle is treated like our own. Here's what makes us Calgary's preferred mobile tire crew.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-2xl overflow-hidden border border-white/10">
          {ITEMS.map(({ icon: Icon, title, desc }) => (
            <div key={title} className="bg-brand-black p-7 hover:bg-neutral-900 transition-colors">
              <div className="w-10 h-10 rounded-lg bg-brand-red/15 text-brand-red flex items-center justify-center">
                <Icon className="w-5 h-5" />
              </div>
              <h3 className="mt-5 font-display font-bold text-lg text-white">{title}</h3>
              <p className="mt-2 text-sm text-white/70 leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
